export const formatProgressBarSteps = barSteps => {
  const urlIndex = window.location.pathname;
  const urls = urlIndex.split("/");
  const currentStep = barSteps?.findIndex(s => {
    return s.fields.route.value.href.includes(urls[urls.length - 1]);
  });

  let _barSteps = [];

  for (let i = 0; i < barSteps?.length; i++) {
    let step = {
      label: barSteps[i].fields.label.value,
      route: barSteps[i].fields.route.value.href,
      disabled: i > currentStep
    };
    _barSteps.push(step);
  }

  return { _barSteps, currentStep };
};
